export default __webpack_public_path__ + "static/media/DNo.21-3.d30af101.jpg";